export default {"src":"/_next/static/media/add-blue.2881d6c4.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};